import img1 from "../assets/ET1.png";
import img2 from "../assets/ET2.png";
import img3 from "../assets/ET3.png";

export default {
  items: [
    {
      id: 1,
      // caption:"Slide 1",
      img: img1,
      // description:"Add The 1st slide"
    },
    {
      id: 2,
      img: img2,
      // caption:"slide 2",
      // description:"Add The 2nd slide"
    },
    {
      id: 3,
      img: img3,
      // caption:"slide 3",
      // description:"Add The 3rd slide"
    },
  ],
};
